import { render, staticRenderFns } from "./WaitlistItemEditor.vue?vue&type=template&id=4d785805"
import script from "./WaitlistItemEditor.vue?vue&type=script&lang=ts"
export * from "./WaitlistItemEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports